import { render, staticRenderFns } from "./StReferences.vue?vue&type=template&id=3d2aa001"
import script from "./StReferences.vue?vue&type=script&lang=ts"
export * from "./StReferences.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports